module.exports = __webpack_public_path__ + "media/banner/banner-logo-2022-211fb3ab.png";